import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';
import Button from '../Button';

// import BackgroundImg from '../../assets/images/Food.jpg';

import Container from '../../components/Container';
const Bannertext = styled.section`
  
  padding:50px 0px;
  color: ${({ theme }) => theme.whiteColor};
  position: relative;
  z-index:1;
  background-size: cover;
  
  .mask{
    content: "";
    z-index: -1;
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  div{
    text-align:center;
    h1{
      padding:0px;
      margin:0px 0px 10px 0px;
      font-size:52px;
    }
    small{
      font-size:14px;
      line-height:22px;
    }
    input[type="text"]{
      background:${({ theme }) => theme.whiteColor};
      padding:15px 20px;
      border:0px;
      width:50%;
      margin:30px 0px 0px 0px;
    }
    button{
      padding:15px 20px;
      background:${(props) => props.theme.primaryColor};
      border:none;
      color: ${({ theme }) => theme.whiteColor};
      margin-left:5px;
      cursor:pointer;
    }
  }

`;

function BannerText(props) {
  const { title, content, button, BackgroundImg } = props;
  return (
    <Bannertext style={{ backgroundImage: `url(${BackgroundImg})` }}>
      <div className="mask" />
      <Container>
        <Flex flexWrap="wrap">
          <Box w={[2 / 12]}>
          </Box>
          <Box w={[8 / 12]}>
            <div>
              <h1>{title}</h1>
              <small>{content}</small><br /><br />
              {button && <Button type="primary">{button}</Button>}
            </div>
          </Box>
          <Box w={[2 / 12]}>
          </Box>
        </Flex>
      </Container>
    </Bannertext>
  );
}

BannerText.propTypes = {
  title: propTypes.string,
  content: propTypes.string,
  button: propTypes.string,
  BackgroundImg: propTypes.string,
};

export default BannerText;



// WEBPACK FOOTER //
// client/components/BannerText/index.js